const furnitures = [
  { name: 'Rooms', path: 'rooms', layout: '' },
  { name: 'Inventory', path: 'inventory', layout: '' },
  { name: 'BoxConfig', path: 'boxes', layout: '' },
  { name: 'BoxDelivery', path: 'boxes-delivery', layout: '' },
];

const children = [
  ...furnitures.map(elem => ({
    path: elem.path,
    component: elem.name,
    name: `furnitures${elem.name}`,
    meta: { layout: elem.layout },
  })),
];


export default children;
